import {
  Box,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { MaskedInput } from '@/components/shared/masked-input';
import { type CreditCardFormData } from '@/packages/courses/pages/checkout/schema';

export const CreditCardDetailsStep = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreditCardFormData>();

  return (
    <Box>
      <Typography variant="h1" color="primary.dark" mb={4}>
        Cartão de crédito
      </Typography>
      <Stack spacing={3}>
        <Controller
          name="number"
          control={control}
          render={({ field }) => (
            <Box>
              <FormLabel htmlFor="number">Número do cartão</FormLabel>
              <MaskedInput
                {...field}
                fullWidth
                mask="0000 0000 0000 0000"
                placeholder="0000 0000 0000 0000"
                error={!!errors.number}
                helperText={errors.number?.message}
              />
            </Box>
          )}
        />
        <Controller
          name="holder_name"
          control={control}
          render={({ field }) => (
            <Box>
              <FormLabel htmlFor="holder_name">Nome do titular</FormLabel>
              <TextField
                {...field}
                fullWidth
                placeholder="Ex.: Pedro Silva"
                error={!!errors.holder_name}
                helperText={errors.holder_name?.message}
                onChange={(e) => field.onChange(e.target.value.toUpperCase())}
              />
            </Box>
          )}
        />
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Controller
              name="expiration"
              control={control}
              render={({ field }) => (
                <Box>
                  <FormLabel htmlFor="expiration">Vencimento</FormLabel>
                  <MaskedInput
                    {...field}
                    fullWidth
                    mask="00/00"
                    placeholder="MM/AA"
                    error={!!errors.expiration}
                    helperText={errors.expiration?.message}
                  />
                </Box>
              )}
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <Controller
              name="cvv"
              control={control}
              render={({ field }) => (
                <Box>
                  <FormLabel htmlFor="cvv">Código de segurança</FormLabel>
                  <MaskedInput
                    {...field}
                    fullWidth
                    mask="0000"
                    placeholder="123"
                    error={!!errors.cvv}
                    helperText={errors.cvv?.message}
                  />
                </Box>
              )}
            />
          </Grid>
        </Grid>
        <Controller
          name="holder_document"
          control={control}
          render={({ field }) => (
            <Box>
              <FormLabel htmlFor="holder_document">CPF do Titular</FormLabel>
              <MaskedInput
                {...field}
                fullWidth
                mask="000.000.000-00"
                placeholder="000.000.000-00"
                error={!!errors.holder_document}
                helperText={errors.holder_document?.message}
              />
            </Box>
          )}
        />
      </Stack>
    </Box>
  );
};
